module.exports = __webpack_public_path__ + "img/BaseIntroduction.65ac4ca6.jpg";